<template>
<div class="chapter">
<div class="inner_page">
<p class="first" id="Copyright">InterVarsity Press<br/>
  P.O. Box 1400<br/>
  Downers Grove, IL 60515-1426<br/>
  World Wide Web: <a href="http://www.ivpress.com" target="_blank">www.ivpress.com</a><br/>
  E-mail: <a href="mailto:email@ivpress.com">email@ivpress.com</a></p>
<p class="first">All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</p>
<p class="first">InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept. InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at www.intervarsity.org.</p>
<p class="first">ISBN: 978-0-8308-5866-8</p>
<p class="first">Copyright © 2010 by Bob Sjogren and Gerald Robison</p>
<p class="first">All Scripture quotations, unless otherwise indicated, are taken from the NEW AMERICAN STANDARD BIBLE ®, Copyright © 1960, 1962, 1963, 1968, 1971, 1972, 1973, 1975, 1977, 1995 by The Lockman Foundation. Used by permission.<br/></p>
<p class="first">Scripture quotations marked (NIV) are taken from the HOLY BIBLE, NEW INTERNATIONAL VERSION® NIV®. Copyright © 1973, 1978, 1984 by Biblica, Inc.™. Used by permission of Zondervan. All rights reserved worldwide.</p>
<p class="first">Scripture quotations marked (ESV) are taken from The Holy Bible, English Standard Version, copyright © 2001 by Crossway Bibles, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.</p>
<p class="first">Scripture quotations marked (NLT) are taken from the <i>Holy Bible</i>, New Living Translation, copyright © 1996, 2004. Used by permission of Tyndale House Publishers, Inc., Wheaton, Illinois 60189. All rights reserved.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?51de0eff